import { useCallback, useEffect, useMemo, useState, useTransition } from 'react';
import { ThemeRecommendList } from './ThemeRecommendList';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { Loading } from 'app/components/Loading';
import { ThemeRecommendBooks } from './ThemeRecommendBooks';
import { ErrorMessage } from 'app/recommend/ErrorMessage';
import { useParams } from "react-router-dom";

export const ThemeRecommend = ()=>{
    const { school } = useParams();
    const [openRecommendList, setOpenRecommendList] = useState(false);
    const [isPending, startTransition] = useTransition();
    const [themeId, setThemeId] = useState(null);

    // 주제별 추천 목록을 가져온다.
    const {data:themeRecommendLatest, isLoading, isSuccess, isError} = useQuery({
        queryKey:['recommend/theme'],
        queryFn:()=>Api.get('/api/recommend/theme'),
        staleTime:1000*60*60,
    });

    // useQuery 에서 적절한 이벤트 있을꺼 같은데...
    useEffect(() => {
        if(themeRecommendLatest?.data?.length>0)setThemeId(themeRecommendLatest?.data[0].id)
    }, [themeRecommendLatest])

    // 
    const onChangeThemeRecommend = useCallback((id)=>{
        if(isPending)return ;
        startTransition(()=>{
            setThemeId(id);
            setOpenRecommendList(false);
        });
    }, [isPending]);

    // 텝 머리를 만든다
    const tabHeader = useMemo(() => {
        if(isLoading)return null;
        if(!isSuccess)return null;
        //목록이 없으면 중단
        if(themeRecommendLatest.data?.length<=0)return null;
        return themeRecommendLatest.data?.map( (recommend, key)=>{
            return (
                <li className={`like ${themeId===recommend.id?'active':''}`} onClick={()=>onChangeThemeRecommend(recommend.id)} key={recommend.id}>
                    <h3 className="thirdTitle">{ recommend.title }</h3>
                </li>
            );
        });
    }, [isLoading, isSuccess, themeRecommendLatest, themeId, onChangeThemeRecommend]);

    if(isLoading)return null;
    if(!isSuccess)return null;
    
    return (
        <div className="themeRecommend" id="themeRecommend">
            <h2 className="subTitle">주제별 추천도서</h2>
            <div className="tab">
                <ul>{tabHeader}</ul>
            </div>
            <div className="section theme">
                <button className={`btn moreBtn ${openRecommendList===true?'active':''}`} onClick={()=>setOpenRecommendList(!openRecommendList)}></button>
                <div className={`guide ${openRecommendList===true?'active':''}`}>
                    <div className="text">주제 더보기</div>
                    <div className="deco"></div>
                </div>
                { isError && <ErrorMessage message="주제별 추천도서가 없습니다." link={`/${school}/signin`} /> }
                { isPending ? <Loading /> : 
                    <>
                        { openRecommendList && <ThemeRecommendList themeId={themeId} onChange={onChangeThemeRecommend} /> }
                        { !openRecommendList && themeId && <ThemeRecommendBooks themeId={themeId} />}
                    </>
                }
            </div>
            <div className="dashedLine"></div>
        </div>
    );                
};